import { Component, OnInit, Input, HostBinding, ViewEncapsulation } from '@angular/core';
import { resolveThemeCssClass } from '../lib/helper/panel-settings';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import get from 'lodash.get';
import { MqService } from 'src/app/service/mq.service';
import { IPictureData } from 'src/app/shared/components/picture/picture.component';
import { ThumbnailBuilderService } from './service/thumbnail-builder.service';
import { IVideoPickerData, IVideoPickerVideoData } from 'src/app/shared/interface/video-picker-data';

interface VideoPanelData {
  title?: IUProperty<string>;
  description?: IUProperty<string>;
  video?: IUProperty<IVideoPickerData>;
  showFullSize: IUProperty<boolean>;
  panelSettings?: any;
  anchor: IUProperty<string>;
}

export interface IVideoViewModel {
  video: object;
  videoTitle: string;
  thumbnail: IPictureData;
  title: IUProperty<string>;
  description?: IUProperty<string>;
  params: string;
}

@Component({
  selector: "app-video-panel",
  templateUrl: "./video-panel.component.html",
  styleUrls: ["./video-panel.component.less"],
  encapsulation: ViewEncapsulation.None,
})
export class VideoPanelComponent implements OnInit {
  @Input() data: VideoPanelData;
  @HostBinding("class") get hostClasses() {
    return resolveThemeCssClass(this.data.panelSettings);
  }

  videoData: IVideoViewModel;
  isShow: boolean = false;
  showFullSize: boolean;

  constructor(
    private thumbnailBuilder: ThumbnailBuilderService,
    private mq: MqService
  ) {}

  ngOnInit() {
    this.mq.mobileDesktop(this.mobile.bind(this), this.desktop.bind(this));
    this.showFullSize = this.data.showFullSize.value;
  }

  mobile() {
    this.videoData = this.prepareVm(get(this.data, "video.value.mobile"));
  }
  desktop() {
    this.videoData = this.prepareVm(get(this.data, "video.value.desktop"));
  }

  open() {
    this.isShow = true;
  }
  close() {
    this.isShow = false;
  }

  private prepareVm(data: IVideoPickerVideoData): IVideoViewModel {
    if (!data) return null;

    return {
      thumbnail: this.thumbnailBuilder.create(data.thumbnail),
      title: this.data.title,
      description: this.data.description,
      params: `?controls=1&muted=0&autoplay=1&showinfo=0`,
      video: {
        url: data.url,
        type: data.type,
      },
      videoTitle: data.title,
    };
  }
}
